<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    max-width="1200px"
    persistent
    scrollable
    @keydown.esc="close"
  >
    <v-card>
      <v-card-title>
        <v-icon left>mdi-history</v-icon>
        <span>{{ $t('payment-method-ui.transactions') }}</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="close" :aria-label="$t('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-4">
        <payment-transaction-list
          :organization-id="organizationId"
          :customer-id="customerId"
          :payment-method-id="paymentMethodId"
          :beneficiary-id="beneficiaryId"
          :page-size="pageSize"
          :auto-load="autoLoad"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">
          {{ $t('close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PaymentTransactionList from '@/components/elements/PaymentTransactionList.vue'

export default {
  name: 'PaymentTransactionListModal',

  components: {
    PaymentTransactionList
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    organizationId: {
      type: String,
      default: null
    },
    customerId: {
      type: String,
      default: null
    },
    paymentMethodId: {
      type: String,
      default: null
    },
    beneficiaryId: {
      type: String,
      default: null
    },
    pageSize: {
      type: Number,
      default: 20
    },
    autoLoad: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    close() {
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped>
/* Modal specific styles */
</style>
